'use client';
import React from 'react';
import { Card, Button, Flowbite } from 'flowbite-react';
import {
  buttonTheme,
  centerText,
  datePickerTheme,
} from '../components/themes.js';
import eddy from '../images/eddy.jpg';
import matias from '../images/matias.jpeg';
import claudio from '../images/claudio.jpg';
import ronald from '../images/ronald.jpeg';
import Footer  from '../components/Footer';

export default function AboutUs() {
  return (
    <div className="flex flex-col items-center">
      <h2 className="text-3xl font-bold">About us</h2>
      <p>Get to know our app developers! </p>
      <br />
      <br />
      <div className="flex flex-col md:flex-row gap-[20px] items-center">
        <Card className="flex items-center" style={{ width: '300px' }}>
          <div className="w-75 h-75 flex flex-col items-center">
            <img
              src={claudio}
              alt="Claudio"
              className="object-cover w-48 h-48 rounded-full"
              style={{ width: '200px', height: '200px' }}
            />
            <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              <br />
              <p>Claudio Parra</p>
            </h5>
            <div className="font-normal text-gray-700 dark:text-gray-400 flex flex-col items-center">
              <p>Software Engineering Student at</p>
              <p>Brigham Young University - Idaho</p>
            </div>
            <br />
            <Flowbite theme={{ theme: buttonTheme }}>
              <a href="https://www.linkedin.com/in/claudio-parra-inostroza/" target="_blank" rel="noopener noreferrer">
                <Button color="primary" className="w-full" type="submit">
                  Visit LinkedIn Profile
                </Button>
              </a>
            </Flowbite>
          </div>
        </Card>
        <Card
          className="w-75 h-75 flex items-center"
          style={{ width: '300px' }}
        >
          <div className="w-75 h-75 flex flex-col items-center">
            <img
              src={eddy}
              alt="Eddy"
              className="object-cover w-48 h-48 rounded-full"
              style={{ width: '200px', height: '200px' }}
            />
            <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              <br />
              <p>Eddy Renteria</p>
            </h5>
            <div className="font-normal text-gray-700 dark:text-gray-400 flex flex-col items-center">
              <p>Software Engineering Student at</p>
              <p>Brigham Young University - Idaho</p>
            </div>
            <br />
            <Flowbite theme={{ theme: buttonTheme }}>
              <a href="https://www.linkedin.com/in/edisson-a-renteria-a-/">
                <Button color="primary" className="w-full" type="submit">
                  Visit LinkedIn Profile
                </Button>
              </a>
            </Flowbite>
          </div>
        </Card>
        <Card
          className="w-75 h-75 flex items-center"
          style={{ width: '300px' }}
        >
          <div className="w-75 h-75 flex flex-col items-center">
            <img
              src={ronald}
              alt="Ronald"
              className="object-cover w-48 h-48 rounded-full"
              style={{ width: '200px', height: '200px' }}
            />
            <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              <br />
              <p>Ronald Coello</p>
            </h5>
            <div className="font-normal text-gray-700 dark:text-gray-400 flex flex-col items-center">
              <p>Software Engineering Student at</p>
              <p>Brigham Young University - Idaho</p>
            </div>
            <br />
            <Flowbite theme={{ theme: buttonTheme }}>
              <a href="https://www.linkedin.com/in/ronaldcoello/">
                <Button color="primary" className="w-full" type="submit">
                  Visit LinkedIn Profile
                </Button>
              </a>
            </Flowbite>
          </div>
        </Card>
        <Card
          className="w-75 h-75 flex items-center"
          style={{ width: '300px' }}
        >
          <div className="w-75 h-75 flex flex-col items-center">
            <img
              src={matias}
              alt="Matias"
              className="object-cover w-48 h-48 rounded-full"
              style={{ width: '200px', height: '200px' }}
            />
            <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              <br />
              <p>Matias Villar</p>
            </h5>
            <div className="font-normal text-gray-700 dark:text-gray-400 flex flex-col items-center">
              <p>Computer Science Student at</p>
              <p>Brigham Young University - Idaho</p>
            </div>
            <br />
            <Flowbite theme={{ theme: buttonTheme }}>
              <a href="https://www.linkedin.com/in/matiasvillar/" target="_blank" rel="noopener noreferrer">
                <Button color="primary" className="w-full" type="submit">
                  Visit LinkedIn Profile
                </Button>
              </a>
            </Flowbite>
          </div>
        </Card>
      </div>
      <Footer/>
    </div>
  );
}
